import { FieldConfig } from "../Components/Form/FormComponent/types";

export const universityListingFields: FieldConfig[] = [
  {
    label: "University Name",
    name: "universityName",
    type: "text",
    required: true,
  },
  {
    label: "Intro",
    name: "intro",
    type: "textarea", // Change from 'text' to 'textarea'
    placeholder: "Enter introduction...",
  },
  { label: "Key Info", name: "keyInfo", type: "tags" },
  { label: "Rankings", name: "rankings", type: "tags" },
  {
    label: "Campus",
    name: "campus",
    type: "objectList",
    objectFields: [
      { key: "location", label: "Location", type: "text" },
      { key: "iframe", label: "Map Link", type: "text" },
    ],
  },
  {
    label: "Country",
    name: "country",
    type: "select",
    options: [
      "Malaysia",
      "Australia",
      "United Kingdom",
      "New Zealand",
      "Singapore",
    ],
  },
  {
    label: "Degree Intake",
    name: "degreeIntake",
    type: "tags",
  },
  {
    label: "Diploma Intake",
    name: "diplomaIntake",
    type: "tags",
  },
  {
    label: "Foundation Intake",
    name: "foundationIntake",
    type: "tags",
  },
  {
    label: "Master Intake",
    name: "masterIntake",
    type: "tags",
  },
  { label: "Courses", name: "courses", type: "tags" },
  {
    label: "Strengths & Highlights",
    name: "strengthsHighlights",
    type: "tags",
  },
];
